import React from 'react';
import styled from 'styled-components';

import { Tag } from '../../../types/shared';

interface ContentSectionHeaderProps {
  title: string;
  tags: Tag[];
}

const ContentSectionHeader = ({ title, tags }: ContentSectionHeaderProps) => {
  const titleWithTags = () => {
    return tags.reduce((totalText, tag, index) => {
      let tagText = (
        <span>
          {' '}
          <SpanBold>{tag?.name}</SpanBold>
        </span>
      );

      if (tags.length === 1) {
        tagText = (
          <span>
            {' '}
            <SpanBold>{tag?.name}</SpanBold>.
          </span>
        );
      }

      if (tags.length > 1 && index !== tags.length - 2) {
        tagText = (
          <span>
            {' '}
            <SpanBold>{tag?.name}</SpanBold>,
          </span>
        );
      }

      if (tags.length > 1 && index === tags.length - 1) {
        tagText = (
          <span>
            {' '}
            en <SpanBold>{tag?.name}</SpanBold>.
          </span>
        );
      }

      return (
        <span key={index}>
          {totalText} {tagText}
        </span>
      );
    }, title);
  };

  return (
    <div aria-level="2" data-testid="header-container">
      {tags ? titleWithTags() : title}
    </div>
  );
};

export default ContentSectionHeader;

export const SpanBold = styled.span`
  font-family: ${({ theme }) => theme.fontCondensed};
  font-weight: 700;
`;
